export const calcSubTotal = (item) =>
  Math.round(
    parseFloat(item.qty) *
      parseFloat(item.unit_price) *
      parseFloat(item.konstanta)
  );

export const calcGrandTotal = (data = []) =>
  data.reduce((total, item) => total + calcSubTotal(item), 0);
